import { useEffect } from 'react';
import type { SelectionEvent } from './types';
import { isSelectionEvent } from './types';

const defaultDomain = 'object' as const;

interface SelectionEventsProps {
  domain?: string;
  onSelect: (event: SelectionEvent) => void;
}

const getSelectEventType = (domain?: string) =>
  `${domain ?? defaultDomain}-select`;

export const useSelectionEvents = ({
  domain,
  onSelect,
}: SelectionEventsProps) =>
  useEffect(() => {
    const handler = (e: Event) => isSelectionEvent(e) && onSelect(e);
    document.addEventListener(getSelectEventType(domain), handler);
    return () => {
      document.removeEventListener(getSelectEventType(domain), handler);
    };
  }, [domain, onSelect]);

export interface SelectDetails {
  selectedIds: string[];
}

interface EmitSelectInput extends SelectDetails {
  domain?: string;
}

export const emitSelectEvent = ({ domain, selectedIds }: EmitSelectInput) => {
  document.dispatchEvent(
    new CustomEvent<SelectDetails>(getSelectEventType(domain), {
      detail: { selectedIds },
    })
  );
};
